import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import CoupleImage from '../assets/couples-account-image.jpg';
import BusinessImage from '../assets/business-account-image.jpg';

import '../styles/ChooseAccountPage.css';

export default function ChooseAccountPage() {
  const { user_id } = useParams();         // ← snake_case to match your route
  const navigate = useNavigate();

  const pick = async (type) => {
    localStorage.setItem('accountType', type);

    // 1) Save account type
    await fetch(
      `https://api.bestday2marry.com/set_user_type/?user_id=${user_id}&user_type=${type}`,
      { method: 'POST', credentials: 'include' }
    );

    // 2) Trigger email verification
    await fetch(
      `https://api.bestday2marry.com/email_verification/?user_id=${user_id}`,
      { credentials: 'include' }
    );

    // 3) Go to verify-code screen
    navigate(`/user_verification/${user_id}`);
  };

  return (
    <div className="choose-body">
      <div className="logo"><a href="/">BestDay2Marry</a></div>
      <div className="choose-container">
        <h1>Choose Your Account Type</h1>
        <p className="choose-blurb">
          Select the plan that best fits your needs.
        </p>

        <div className="cards-row">
          <div className="account-card" onClick={() => pick('couple')}>
            <div className="card-left">
              <h2>Couple</h2>
              <p>Shared dashboards and guest matching for two.</p>
            </div>
            <div className="card-right">
              <img src={CoupleImage} alt="Couple" />
            </div>
          </div>

          <div className="card-or">or</div>

          <div className="account-card" onClick={() => pick('business')}>
            <div className="card-left">
              <h2>Business</h2>
              <p>Advanced analytics and team access for venues.</p>
            </div>
            <div className="card-right">
              <img src={BusinessImage} alt="Business" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}